import { isOpenQuestionPin, TeacherPin } from '@lessonup/pins-shared';
import { parseStringWithOptions } from '@lessonup/utils';

export type OpenQuestionEvaluationOptions = {
  caseSensitive: boolean;
  diacriticSensitive: boolean;
};

function normalize(text: string, options: OpenQuestionEvaluationOptions): string {
  const parsed = parseStringWithOptions(text, {
    asLowercase: !options.caseSensitive,
    normalizeDiacritics: !options.diacriticSensitive,
  });
  // Collapse internal whitespace and trim again for robust matching
  return parsed.replace(/\s+/g, ' ').trim();
}

export function isOpenQuestionAnswerCorrect(
  studentText: string,
  correctAnswers: string[],
  options: OpenQuestionEvaluationOptions
): boolean {
  if (!studentText || correctAnswers.length === 0) return false;
  const normalizedStudent = normalize(studentText, options);
  return correctAnswers.some((answer) => normalize(answer, options) === normalizedStudent);
}

export function getCorrectAnswersFromPin(pin?: TeacherPin) {
  if (!pin || !isOpenQuestionPin(pin)) return null;
  return pin.teacherSettings.correctAnswers?.length ? pin.teacherSettings.correctAnswers : undefined;
}
